import { Injectable, signal } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AppProperty {

  // Signals (non Promise riassegnate): i gate nei template si aggiornano in modo
  // deterministico con qualsiasi strategia di change detection, senza race sul
  // momento della sottoscrizione dell'AsyncPipe.
  readonly dataLoaded = signal(false);
  readonly loadingData = signal(false);
  readonly loginPageNotVisible = signal(false);

  assistantUserMessage: string;

  private _appClass: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  public appClass: Observable<any> = this._appClass.asObservable();

  private _appName: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  public appName: Observable<any> = this._appName.asObservable();

  private _isImpersonateActive: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  public isImpersonateActive: Observable<any> = this._isImpersonateActive.asObservable();

  private _newAlertReceived: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public newAlertReceived: Observable<boolean> = this._newAlertReceived.asObservable();

  private _voiceRecordingState: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public voiceRecordingState: Observable<boolean> = this._voiceRecordingState.asObservable();

  constructor() { }

  public setAppClass(appClass: any): void {
    this._appClass.next(appClass);
  }
  public get appStyleClass(): any {
    return this._appClass.getValue();
  }

  public setAppName(appName: any): void {
    this._appName.next(appName);
  }
  public get appFuctionName(): any {
    return this._appName.getValue();
  }

  public setIsImpersonateActive(isImpersonateActive: any): void {
    this._isImpersonateActive.next(isImpersonateActive);
  }

  public get impersonateIsActive(): any {
    return this._isImpersonateActive.getValue();
  }

  public setNewAlertReceived(newAlertReceived: any): void {
    this._newAlertReceived.next(newAlertReceived);
  }
  public get receivedNewAlert(): any {
    return this._newAlertReceived.getValue();
  }

  public setRecordingState(voiceRecordingState: any): void {
    this._voiceRecordingState.next(voiceRecordingState);
  }
  public get recordingState(): any {
    return this._voiceRecordingState.getValue();
  }
}
